import { render, staticRenderFns } from "./AppBouwdepot.vue?vue&type=template&id=256d525f&scoped=true&"
import script from "./AppBouwdepot.ts?vue&type=script&lang=ts&"
export * from "./AppBouwdepot.ts?vue&type=script&lang=ts&"
import style0 from "./AppBouwdepot.scss?vue&type=style&index=0&id=256d525f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256d525f",
  null
  
)

export default component.exports